import { Theme, css } from '@emotion/react';

export const root = (theme: Theme) => css`
  width: 42px;
  height: 26px;
  padding: 0;
`;

export const rootSmall = (theme: Theme) => css`
  width: 34px;
  height: 18px;
  padding: 0;
`;

export const rootLarge = (theme: Theme) => css`
  width: 50px;
  height: 34px;
  padding: 0;
`;

export const switchBase = (theme: Theme) => css`
  padding: 1px !important;

  &.Mui-checked {
    transform: translateX(16px);
    color: ${theme.colors.white};
  }

  &.Mui-disabled {
    color: ${theme.colors.disabled};
  }

  &.Mui-checked + .MuiSwitch-track {
    background-color: ${theme.colors.backgroundSuccess};
    opacity: 1;
  }

  &.Mui-disabled + .MuiSwitch-track {
    background-color: ${theme.colors.disabledBackground};
    opacity: 1;
  }

  &.Mui-focusVisible .MuiSwitch-thumb {
    color: ${theme.colors.backgroundSuccess};
    border: 6px solid ${theme.colors.white};
  }
`;

export const thumbLarge = (theme: Theme) => css`
  width: 32px;
  height: 32px;
`;

export const thumb = (theme: Theme) => css`
  width: 24px;
  height: 24px;
`;

export const thumbSmall = (theme: Theme) => css`
  width: 16px;
  height: 16px;
`;

export const track = (theme: Theme) => css`
  border-radius: 13px;
  border: 1px solid ${theme.colors.borderLight};
  background-color: ${theme.colors.backgroundLightest};
  opacity: 1;
  transition:
    background-color 300ms cubic-bezier(0.4, 0, 0.2, 1),
    border 300ms cubic-bezier(0.4, 0, 0.2, 1);
`;

export const trackSmall = (theme: Theme) => css`
  border-radius: 9px;
  border: 1px solid ${theme.colors.borderLight};
  background-color: ${theme.colors.backgroundLightest};
  opacity: 1;
  transition:
    background-color 300ms cubic-bezier(0.4, 0, 0.2, 1),
    border 300ms cubic-bezier(0.4, 0, 0.2, 1);
`;

export const trackLarge = (theme: Theme) => css`
  border-radius: 17px;
  border: 1px solid ${theme.colors.borderLight};
  background-color: ${theme.colors.backgroundLightest};
  opacity: 1;
  transition:
    background-color 300ms cubic-bezier(0.4, 0, 0.2, 1),
    border 300ms cubic-bezier(0.4, 0, 0.2, 1);
`;

export const disabled = (theme: Theme) => css``;

export const checked = (theme: Theme) => css``;

export const focusVisible = (theme: Theme) => css``;
